// @flow
import React from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import Payer from 'screens/payer';
import PayerSetup from 'screens/payer-setup';
import SignIn from 'screens/sign-in';
import SessionsList from 'screens/sessions/list';
import SessionsCreate from 'screens/sessions/create';
import SessionsView from 'screens/sessions/view';
import SessionsEdit from 'screens/sessions/edit';
import TutorRoute from 'routes/tutor-route';
import ResetPassword from 'screens/reset-password';
import ForgotPassword from 'screens/forgot-password';

import { isLoggedInTutor } from 'utils/user-auth';

const Routes = ({ history }: { history: any }) => (
  <ConnectedRouter history={history}>
    <div>
      <Switch>
        <Route
          path="/sign-in"
          render={() => (isLoggedInTutor() ? <Redirect to="/sessions" /> : <SignIn />)}
        />
        <Route path="/payment*" component={Payer} />
        <Route path="/setup-account/:payerId" component={PayerSetup} />

        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/claim-account" render={() => <ResetPassword isForClaimAccount />} />

        <TutorRoute exact path="/sessions" component={SessionsList} />
        <TutorRoute exact path="/sessions/new" component={SessionsCreate} />
        <TutorRoute exact path="/sessions/:sessionId" component={SessionsView} />
        <TutorRoute exact path="/sessions/:sessionId/edit" component={SessionsEdit} />

        <Route
          path="*"
          render={() => (isLoggedInTutor() ? <Redirect to="/sessions" /> : <SignIn />)}
        />
      </Switch>
    </div>
  </ConnectedRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js